import RefreshIcon from "@assets/icons/refresh.svg";
import SuggestedPencilIcon from "@assets/icons/suggestion-pencil.svg";

import { cn } from "@utils/tailwind.util";
import { View } from "@ui/View";

interface AIContextHeaderProps {
  isPending: boolean;
  isError: boolean;
  onRegenerate: () => void;
}

export function AIContextHeader({ isPending, isError, onRegenerate }: AIContextHeaderProps) {
  return (
    <div className="flex justify-between items-center gap-2">
      <div className="flex items-center gap-2">
        {" "}
        <SuggestedPencilIcon className="text-sky-600 scale-[110%]" />
        <h3 className="uppercase text-sm text-gray-550 dark:text-invertedPrimary80">
          Scout context
        </h3>
      </div>

      <View.Condition if={!isPending}>
        <button
          className={cn(
            "h-5 py-0 px-2 flex items-center gap-2 bg-emerald-100 text-emerald-700 hover:bg-emerald-200 text-xs rounded-md cursor-pointer",
            { "bg-red-50 text-content-primary hover:bg-red-100": isError }
          )}
          onClick={onRegenerate}
        >
          <RefreshIcon
            className={cn("scale-125 text-emerald-700", {
              "text-content-primary": isError,
            })}
          />
          <span className="cursor-pointer">{isError ? "Try Again" : "Update"}</span>
        </button>
      </View.Condition>
    </div>
  );
}
